import { createFocusTrap } from '../../../node_modules/focus-trap/dist/focus-trap.esm.js'

export const overlay = document.getElementById('theme-overlay')
export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')
export const navPrimary = document.getElementById('js-navigation-primary')
export const logo = document.getElementById('js-logo')
export const menuParentItems = document.querySelectorAll(
	'.c-menu__link[aria-expanded]'
)

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)

// Admin
export const courseSelect = document.getElementById('course-assigned')
export const adminPostType = document.querySelector('#post #post_type')
export const typeOfCourse = document.querySelectorAll(
	'[name="acf[field_5fdcd4de7eb40]"]'
)
export const isCompletable = document.querySelector('input#completable')

export const likeTriggers = document.querySelectorAll(
	'.cld-like-dislike-trigger'
)

export const expandTranscriptionInside = document.getElementById(
	'js-toggle-transcription-inside'
)
export const expandTranscriptionOutside = document.getElementById(
	'js-toggle-transcription-outside'
)

export const transcriptionBox = document.getElementById('js-transcription')
export const audioToggle = document.getElementById('js-audio-toggle')
export const audioBox = document.getElementById('js-audio')
export const popups = document.querySelectorAll('.js-popup')

export const searchToggle = document.querySelector('#js-search-toggle')
export const searchPopup = document.querySelector('#js-search-popup')
export const focusTrapSearchBox = createFocusTrap('#js-search-popup')
export const focusTrapMenu = createFocusTrap('#js-navigation-primary')
export const searchRestrictions = [
	...document.querySelectorAll('.js-search-type'),
]
export const searchMenuItem = document.querySelector('#js-search-item')
export const searchSubmit = document.getElementById('js-search-submit')
export const sidebar = document.querySelector('#theme-sidebar')
export const viewport = document.documentElement
export const lessonSidebar = document.querySelector('.js-lesson-sidebar')
export const popupToggles = document.querySelectorAll('.js-popup-toggle')
export const excludeSearchToggle = document.getElementById('searchwp_exclude')
export const searchForm = document.getElementById('js-search-form')

export const postTypesFacet = document.querySelector(
	'.facetwp-facet[data-name="programs"]'
)

export const searchTerms = document.getElementById('js-search-terms')
export const header = document.getElementById('theme-header')

const MQ_MENU = '(min-width: 950px)'
export const mqMenu = window.matchMedia(MQ_MENU)
const MQ_SIDEBAR = '(min-width: 900px)'
export const mqSidebar = window.matchMedia(MQ_SIDEBAR)
export const sidebarToggleButton = document.getElementById('js-sidebar-toggle')
export const registerForm = document.querySelector('.js-register-form form')
export const registerUserRoles = [
	...document.querySelectorAll('.js-user-roles input[type="checkbox"]'),
]

export const wistiaEmbed = document.querySelector('.js-wistia-embed')
export const AcceptTermsButtons = document.querySelectorAll('.js-terms-button')
export const AcceptTermsCheckboxes =
	document.querySelectorAll('.js-terms-checkbox')
export const earningsBar = document.getElementById('js-earnings')
export const countdownBar = document.getElementById('js-countdown')
export const countdownContainer = document.getElementById(
	'js-countdown-container'
)
export const surveySubmitButton = document.querySelector(
	'.js-popup-survey .gform_button'
)
export const surveyForm = document.querySelector('.js-popup-survey form')

export const exportUserCompletedLessonsButtons = document.querySelectorAll(
	'.js-export-migration'
)
